import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Plus, Minus } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLang();
  const faqs = [{
    qKey: 'faq1_q',
    aKey: 'faq1_a'
  }, {
    qKey: 'faq2_q',
    aKey: 'faq2_a'
  }, {
    qKey: 'faq3_q',
    aKey: 'faq3_a'
  }, {
    qKey: 'faq4_q',
    aKey: 'faq4_a'
  }, {
    qKey: 'faq5_q',
    aKey: 'faq5_a'
  }, {
    qKey: 'faq6_q',
    aKey: 'faq6_a'
  }];
  return <Section id="faq" background="white" data-id="element-132">
      <div className="grid md:grid-cols-12 gap-8 md:gap-12 lg:gap-24" data-id="element-133">
        <div className="md:col-span-4" data-id="element-134">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mb-6 md:mb-8" data-id="element-135">
            {t('faq_h2')}
          </h2>
          <p className="text-neutral-500 mb-6 md:mb-8 text-base md:text-lg font-light" data-id="element-136">
            {t('faq_subtitle')}
          </p>
          <a href="#contact" className="text-black font-medium text-sm border-b border-black pb-1 hover:text-neutral-600 hover:border-neutral-600 transition-colors inline-block" data-id="element-137">
            {t('faq_ask')}
          </a>
        </div>

        <div className="md:col-span-8" data-id="element-138">
          {faqs.map((faq, index) => <div key={index} className="border-b border-neutral-200 last:border-0" data-id="element-139">
              <button className="w-full flex items-start justify-between py-5 md:py-6 text-left focus:outline-none group" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-140">
                <span className="font-medium text-base md:text-lg text-black pr-4 md:pr-8" data-id="element-141">
                  {t(faq.qKey)}
                </span>
                <span className="flex-shrink-0 mt-1" data-id="element-142">
                  {openIndex === index ? <Minus className="h-4 w-4 text-black" data-id="element-143" /> : <Plus className="h-4 w-4 text-neutral-400 group-hover:text-black transition-colors" data-id="element-144" />}
                </span>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100 mb-5 md:mb-6' : 'max-h-0 opacity-0'}`} data-id="element-145">
                <div className="text-neutral-500 text-sm md:text-base leading-relaxed font-light max-w-2xl pr-4" data-id="element-146">
                  {t(faq.aKey)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}